import React, { useEffect, useState, useContext } from "react";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import DirectionsBoatFilledIcon from '@mui/icons-material/DirectionsBoatFilled';
import Avatar from '@mui/material/Avatar';

import CustomizationContext from "../CustomizationContext";
import IconInfo from "../Shared/IconInfo";
import Component from "./Component";


export const StaticDeck = (props) => {
    const [viewMode, setViewMode] = useState(props.viewMode);
    const customizationCtx = useContext(CustomizationContext);

    return (
        <div className="row">
            <div className="col-12">
                {viewMode === "summary" &&
                    <>
                        <div className="row py-5">
                            <div className="col-12 text-center">
                                <div className="row">
                                    <div className="col-xl-8 col-12">
                                        {props.deck.deckOptionals.map((myOptional, i) => (
                                            <Component key={i} element={myOptional} callBack={props.callBack} enableConfiguration={false} feedbackCallback={props.feedbackCallback} isProfile={props.deck.isProfile} />
                                        ))
                                        }
                                    </div>
                                    <div className="col-xl-4 col-12 text-start">
                                        <p className="deck-title-recap pb-3">{props.deck.deckName}</p>
                                        <List sx={{ width: '100%', maxWidth: 360 }}>
                                            {props.deck.deckOptionals.map((myOptional, i) => (
                                                myOptional.isCustomizable === true &&
                                                <ListItem key={i}>
                                                    <ListItemAvatar>
                                                        <Avatar>
                                                            <DirectionsBoatFilledIcon style={{ color: '#00303C' }} />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={myOptional.componentName} />
                                                    <IconInfo infoMessage={myOptional.componentDescription} />
                                                </ListItem>
                                            ))
                                            }
                                        </List>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {viewMode === "recap" &&
                    <>
                        <p className="deck-title-recap">{props.deck.deckName}</p>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-10">
                                    {props.deck.deckOptionals.map((myOptional, i) => (
                                        myOptional.isCustomizable === true &&
                                        <div key={i} className="row align-items-center pb-2">
                                            <div className="col-4 text-center">
                                                <img src={myOptional.urlThumb} className="w-optional-static" alt={myOptional.componentName} />
                                            </div>
                                            <div className="col-8 text-start">
                                                <p className="text-optional pb-3">{myOptional.componentName}</p>
                                            </div>
                                        </div>
                                    ))
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default StaticDeck;
